export const UPDATE_GROUP_NAME = 'UPDATE_GROUP_NAME'
export const UPDATE_PARTY = 'UPDATE_PARTY'

export const updateGroupName = groupName => {
  return {
    type: UPDATE_GROUP_NAME,
    groupName,
  }
}

export const updateParty = party => {
  return {
    type: UPDATE_PARTY,
    party,
  }
}
